// Google Analytics 4 Event Tracking Utility
// Tag ID: G-6GD57FWXM8

/**
 * Track a custom event in Google Analytics 4
 * @param {string} eventName - Name of the event
 * @param {object} params - Event parameters
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

// ============ USER EVENTS ============

export const trackSignUp = (method = 'google') => {
  trackEvent('sign_up', { method });
};

export const trackLogin = (method = 'google') => {
  trackEvent('login', { method });
};

export const trackLogout = () => {
  trackEvent('logout');
};

// ============ SUBSCRIPTION EVENTS ============

export const trackViewPlans = () => {
  trackEvent('view_plans');
};

export const trackUpgradeStart = (tier, billingPeriod) => {
  trackEvent('begin_checkout', {
    currency: 'CAD',
    value: tier === 'premium' ? (billingPeriod === 'annual' ? 95.90 : 9.99) : (billingPeriod === 'annual' ? 191.90 : 19.99),
    items: [{
      item_id: tier,
      item_name: `${tier.charAt(0).toUpperCase() + tier.slice(1)} Plan`,
      item_category: 'subscription',
      price: tier === 'premium' ? 9.99 : 19.99,
      quantity: 1
    }]
  });
};

export const trackUpgradeComplete = (tier, billingPeriod) => {
  trackEvent('purchase', {
    currency: 'CAD',
    value: tier === 'premium' ? (billingPeriod === 'annual' ? 95.90 : 9.99) : (billingPeriod === 'annual' ? 191.90 : 19.99),
    transaction_id: `SUB_${Date.now()}`,
    items: [{
      item_id: tier,
      item_name: `${tier.charAt(0).toUpperCase() + tier.slice(1)} Plan`,
      item_category: 'subscription',
      price: tier === 'premium' ? 9.99 : 19.99,
      quantity: 1
    }]
  });
};

export const trackCancelSubscription = (tier) => {
  trackEvent('cancel_subscription', { tier });
};

// ============ FEATURE USAGE EVENTS ============

export const trackFeatureUsed = (featureName, details = {}) => {
  trackEvent('feature_used', {
    feature_name: featureName,
    ...details
  });
};

export const trackMortgageSaved = () => {
  trackEvent('mortgage_saved');
};

export const trackScenarioCreated = () => {
  trackEvent('scenario_created');
};

export const trackRateAlertCreated = (rateType, targetRate) => {
  trackEvent('rate_alert_created', {
    rate_type: rateType,
    target_rate: targetRate
  });
};

export const trackRateLockCreated = (rateType, targetRate) => {
  trackEvent('rate_lock_created', {
    rate_type: rateType,
    target_rate: targetRate
  });
};

export const trackPDFExport = () => {
  trackEvent('pdf_export');
};

export const trackHELOCCalculation = (type) => {
  trackEvent('heloc_calculation', { calculation_type: type });
};

// ============ ENGAGEMENT EVENTS ============

export const trackOnboardingStarted = () => {
  trackEvent('onboarding_started');
};

export const trackOnboardingCompleted = () => {
  trackEvent('onboarding_completed');
};

export const trackBlogRead = (articleTitle, category) => {
  trackEvent('blog_read', {
    article_title: articleTitle,
    category: category
  });
};

export const trackSupportTicketCreated = (category) => {
  trackEvent('support_ticket_created', { category });
};

// ============ PAGE VIEW EVENTS ============

export const trackPageView = (pageName, pagePath) => {
  trackEvent('page_view', {
    page_title: pageName,
    page_location: window.location.href,
    page_path: pagePath
  });
};

export const trackTabChange = (tabName) => {
  trackEvent('tab_change', { tab_name: tabName });
};

// ============ ERROR EVENTS ============

export const trackError = (errorType, errorMessage) => {
  trackEvent('error', {
    error_type: errorType,
    error_message: errorMessage
  });
};

// ============ CALCULATOR EVENTS ============

export const trackPaymentShockCalculation = (currentRate, newRate) => {
  trackEvent('payment_shock_calculation', {
    current_rate: currentRate,
    new_rate: newRate
  });
};

export const trackAmortizationView = (viewType) => {
  trackEvent('amortization_view', { view_type: viewType });
};
